import React from 'react';

const readUsername = () => {
  const v = localStorage.getItem('username');
  return v && v !== 'undefined' ? v : null;
};

// "Charles Sio" → "Charles"; "charles@x.com" → "charles"; nothing → "there"
const firstName = (raw) => {
  if (!raw) return 'there';
  const noEmail = raw.includes('@') ? raw.split('@')[0] : raw;
  const first = noEmail.split(/[\s._]/)[0].trim();
  return first || 'there';
};

const fmtToday = () => new Date().toLocaleDateString('en-US', {
  weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
});

export default function DashboardGreeting({ clientName, syncedAgo }) {
  const name = firstName(readUsername());
  return (
    <header className="mb-8">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
        Hi, {name} <span className="align-middle" aria-hidden>👋</span>
      </h1>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
        {clientName ? (
          <>Here's what's happening at <span className="font-medium text-gray-900 dark:text-gray-100">{clientName}</span> today.</>
        ) : (
          <>Pick a property from the header to see today's numbers.</>
        )}
      </p>
      <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">
        {fmtToday()}{syncedAgo ? ` · Last synced ${syncedAgo}` : ''}
      </p>
    </header>
  );
}
